import {Dropdown} from "react-bootstrap";
import SettingsIcon from "@mui/icons-material/Settings";
import React from "react";
import RecebivelRuralDetails from "./RecebivelRuralDetails";


export default function RecebivelRuralActions({item, baseUrl}) {

    return <Dropdown drop='down-centered'>
        <Dropdown.Toggle
            variant="secondary"
        >
            Ações &nbsp;
            <SettingsIcon fontSize="medium"/>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <RecebivelRuralDetails item={item} baseUrl={baseUrl}/>
        </Dropdown.Menu>

    </Dropdown>
}